import * as Sentry from '@sentry/react';

const sendToSentry = (errorDetails) => {
  Sentry.captureMessage(errorDetails.message, {
    level: 'warning',
    extra: errorDetails,
  });
};

export default sendToSentry